/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStatus1d2Enum } from './APIStatus1d2Enum';
import {
    APIStatus1d2EnumFromJSON,
    APIStatus1d2EnumFromJSONTyped,
    APIStatus1d2EnumToJSON,
} from './APIStatus1d2Enum';

/**
 * Mixin to provide model-field level permissions on the serializer level.
 * 
 * How to use:
 *     1. Add the mixin as the first inherited class to your serializer (at
 *        least before the SerializerExtensionsMixin).
 *     2. Make sure that Meta.model is specified on your serializer.
 *     3. Define a 'get_forbidden_fields' classmethod on the according model
 *        class that returns a list of fieldnames for all fields that a user
 *        is *not* allowed to view/edit. Example:
 * 
 *             @classmethod
 *             def get_forbidden_fields(cls, action: Literal["view", "create", "edit"],
 *                                      user) -> List[str]:
 *                 if action == "view":
 *                     if user.is_staff: return []
 * 
 *                     # for all other users
 *                     return [
 *                         "forbidden_field_name_1",
 *                         "forbidden_field_name_2,
 *                     ]
 *                 if action == "create":
 *                     pass
 *                 if action == "edit":
 *                     pass
 *                 return []
 * 
 * 
 * How to use with expandable fields:
 *     1. Setup the HyperlinkedRelatedField as usual.
 *     2. Add the field that relies on you permission-enriched serializer to
 *        the 'expandable_fields' dict and point it to 'SerializerMethodField'.
 *        (from rest_framework.serializers import SerializerMethodField)
 *     3. Add a serializer method with the name 'get_<expandable_field_name>'
 *        to the serializer that holds the expandable field.
 * 
 *     Example:
 * 
 *             class SerializerB( FieldLevelPermissionSerializerMixin,
 *                                SerializerExtensionMixin,
 *                                HyperlinkedModelSerializer):
 *                 class Meta:
 *                     model=B
 * 
 *             class SerializerA(SerializerExtensionMixin, HyperlinkedModelSerializer):
 *                 field_b = HyperlinkedRelatedField(
 *                     view_name="View-B-detail",
 *                     ...
 *                 )
 * 
 *                 get_field_b(self, obj):
 *                     "   Helper method that provides the nested serializer
 *                         SerializerB with the required information for
 *                         the FieldLevelPermissionSerializerMixin to work.
 *                        "
 *                     return SerializerB(context={
 *                         "request": self.context["request"],
 *                         "view": self.context["view"],
 *                         "expand": [
 *                             # prepare the argument for the next serializer
 *                             expand_arg.removeprefix("field_b__")
 *                             for expand_arg
 *                             in self.context["expand"]
 *                             # remove any arguments that are meant for the current serializer
 *                             if expand_arg.startswith("field_b__")
 *                         ],
 *                     }).to_representation(obj.field_b)
 * 
 *                 class Meta:
 *                     model=A
 *                     expandable_fields=dict(
 *                         field_a=SerializerMethodField
 *                     )
 * @export
 * @interface APIOfferRequest
 */
export interface APIOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof APIOfferRequest
     */
    request: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIOfferRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIOfferRequest
     */
    prices: { [key: string]: any; };
    /**
     * 
     * @type {APIStatus1d2Enum}
     * @memberof APIOfferRequest
     */
    status: APIStatus1d2Enum;
    /**
     * 
     * @type {string}
     * @memberof APIOfferRequest
     */
    remarks?: string;
}



/**
 * Check if a given object implements the APIOfferRequest interface.
 */
export function instanceOfAPIOfferRequest(value: object): value is APIOfferRequest {
    if (!('request' in value) || value['request'] === undefined) return false;
    if (!('prices' in value) || value['prices'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function APIOfferRequestFromJSON(json: any): APIOfferRequest {
    return APIOfferRequestFromJSONTyped(json, false);
}

export function APIOfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOfferRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'request': json['request'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'prices': json['prices'],
        'status': APIStatus1d2EnumFromJSON(json['status']),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function APIOfferRequestToJSON(value?: APIOfferRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'request': value['request'],
        'editors': value['editors'],
        'prices': value['prices'],
        'status': APIStatus1d2EnumToJSON(value['status']),
        'remarks': value['remarks'],
    };
}

